// @ts-check
/** Admin capture and listing of walk-in leads: someone at a sales event who tried a piece but did not buy. */

import api from '../utils/apiClient';

const adminWalkInLeadService = {
  /**
   * @param {{sales_event_id: string, name: string, phone: string, phone_country: string, style: string | null, size_tried: string | null, notes: string | null, measurements?: Record<string, number> | null, fit_notes?: string | null, preferred_product_id?: string | null}} data
   */
  async create(data) {
    return api.post('/api/admin/walk-in-leads', data);
  },

  /** @param {string} [salesEventId] omit for every lead */
  async list(salesEventId) {
    return api.get(`/api/admin/walk-in-leads${salesEventId ? `?sales_event_id=${salesEventId}` : ''}`);
  },

  /**
   * Only the fields you pass change - omit the rest. phone_country (ISO-2) is how a number typed
   * without a leading + is read; the server returns the phone as E.164 and refuses an invalid one (422).
   */
  async update(leadId, data) {
    return api.patch(`/api/admin/walk-in-leads/${leadId}`, data);
  },

  /** Soft delete - the lead drops off the list but the row is kept. */
  async remove(leadId) {
    return api.del(`/api/admin/walk-in-leads/${leadId}`);
  },
};

export default adminWalkInLeadService;
